<div class="graphic">
  <div class="graphic_0">
    @if (graphic() === 'hexagon') {
      <svg width="281" height="303" viewBox="0 0 281 303" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          stroke="var(--bs-secondary)"
          d="M61.5 90.6899V47.9999M171.5 210V256.248M224.511 120.683L277.874 92.2231M61.0351 213.905L5.57911 181.887L5.5791 117.852L61.0351 85.8344L116.491 117.852V181.887L61.0351 213.905ZM170.963 213.905L115.506 181.887L115.506 117.852L170.962 85.8344L226.419 117.852V181.887L170.963 213.905ZM170.962 295.727L152.477 285.055V263.71L170.962 253.037L189.447 263.71V285.055L170.962 295.727ZM60.537 49.6901L42.0517 39.0175V17.6725L60.537 7L79.0223 17.6725L79.0223 39.0175L60.537 49.6901Z"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'rond') {
      <svg width="256" height="251" viewBox="0 0 256 251" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          stroke="var(--bs-secondary)"
          d="M65.5186 171.233L101.186 167M32.554 153.381L37.7678 103.533M65.5723 69.328L119.103 47.0021M156.736 96.6018L151.523 65.9452M146.93 102.031C184.904 86.1931 228.528 104.139 244.366 142.113C260.204 180.088 242.259 223.712 204.284 239.55C166.309 255.388 122.685 237.443 106.847 199.468C91.0093 161.493 108.955 117.869 146.93 102.031ZM25.1007 152.842C41.1572 146.145 59.6022 153.733 66.2988 169.789C72.9954 185.846 65.4077 204.291 49.3513 210.987C33.2948 217.684 14.8498 210.096 8.15319 194.04C1.45658 177.983 9.04424 159.538 25.1007 152.842ZM134.975 8.41979C151.031 1.72318 169.476 9.31084 176.173 25.3673C182.869 41.4238 175.282 59.8688 159.225 66.5654C143.169 73.262 124.724 65.6743 118.027 49.6179C111.331 33.5614 118.918 15.1164 134.975 8.41979ZM33.9908 55.9542C47.2438 50.4268 62.5544 56.8962 68.188 70.4041C73.8217 83.9119 67.645 99.3429 54.3921 104.87C41.1391 110.398 25.8285 103.928 20.1948 90.4204C14.5612 76.9126 20.7379 61.4815 33.9908 55.9542Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'cel') {
      <svg width="238" height="206" viewBox="0 0 238 206" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M167.828 119.218C160.44 131.833 145.419 139.252 125.842 140.078C106.334 140.902 83.0806 135.068 60.9008 122.08C38.7209 109.092 22.2557 91.6675 13.4279 74.2513C4.56884 56.7736 3.68929 40.0432 11.0764 27.4281C18.4635 14.813 33.4845 7.3936 53.0619 6.56749C72.5703 5.74428 95.8233 11.5774 118.003 24.5654C140.183 37.5534 156.648 54.9783 165.476 72.3945C174.335 89.8722 175.215 106.603 167.828 119.218Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
        <path
          d="M133.753 78.7366C128.81 87.1792 109.403 85.0059 90.4066 73.8823C71.4107 62.7588 60.0192 46.8972 64.963 38.4546"
          stroke="var(--bs-secondary)"
          stroke-width="8"
        />
        <path
          d="M226.945 118.602C232.453 124.993 233.904 134.827 230.468 146.44C227.053 157.987 218.954 170.525 206.758 181.034C194.562 191.544 180.966 197.702 169.041 199.374C157.048 201.056 147.536 198.169 142.029 191.777C136.521 185.385 135.07 175.551 138.505 163.938C141.921 152.392 150.02 139.854 162.216 129.344C174.412 118.835 188.008 112.677 199.933 111.005C211.926 109.323 221.437 112.21 226.945 118.602Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
        <path
          d="M196.926 129.528C201.007 134.263 195.677 145.546 185.022 154.728C174.367 163.91 162.421 167.514 158.34 162.779"
          stroke="var(--bs-secondary)"
          stroke-width="8"
        />
      </svg>
    }

    @if (graphic() === 'stippen') {
      <svg width="230" height="244" viewBox="0 0 230 244" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M54.5 55C54.5 63.0081 48.0081 69.5 40 69.5C31.9919 69.5 25.5 63.0081 25.5 55C25.5 46.9919 31.9919 40.5 40 40.5C48.0081 40.5 54.5 46.9919 54.5 55ZM34.5 155C34.5 163.008 28.0081 169.5 20 169.5C11.9919 169.5 5.5 163.008 5.5 155C5.5 146.992 11.9919 140.5 20 140.5C28.0081 140.5 34.5 146.992 34.5 155ZM74.5 113C74.5 121.008 68.0081 127.5 60 127.5C51.9919 127.5 45.5 121.008 45.5 113C45.5 104.992 51.9919 98.5 60 98.5C68.0081 98.5 74.5 104.992 74.5 113ZM126.5 125C126.5 133.008 120.008 139.5 112 139.5C103.992 139.5 97.5 133.008 97.5 125C97.5 116.992 103.992 110.5 112 110.5C120.008 110.5 126.5 116.992 126.5 125ZM168.5 79C168.5 87.0081 162.008 93.5 154 93.5C145.992 93.5 139.5 87.0081 139.5 79C139.5 70.9919 145.992 64.5 154 64.5C162.008 64.5 168.5 70.9919 168.5 79ZM148.5 20C148.5 28.0081 142.008 34.5 134 34.5C125.992 34.5 119.5 28.0081 119.5 20C119.5 11.9919 125.992 5.5 134 5.5C142.008 5.5 148.5 11.9919 148.5 20ZM224.5 91C224.5 99.0081 218.008 105.5 210 105.5C201.992 105.5 195.5 99.0081 195.5 91C195.5 82.9919 201.992 76.5 210 76.5C218.008 76.5 224.5 82.9919 224.5 91ZM202.5 195C202.5 203.008 196.008 209.5 188 209.5C179.992 209.5 173.5 203.008 173.5 195C173.5 186.992 179.992 180.5 188 180.5C196.008 180.5 202.5 186.992 202.5 195ZM146.5 182C146.5 190.008 140.008 196.5 132 196.5C123.992 196.5 117.5 190.008 117.5 182C117.5 173.992 123.992 167.5 132 167.5C140.008 167.5 146.5 173.992 146.5 182ZM104.5 224C104.5 232.008 98.0081 238.5 90 238.5C81.9919 238.5 75.5 232.008 75.5 224C75.5 215.992 81.9919 209.5 90 209.5C98.0081 209.5 104.5 215.992 104.5 224Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
        <path
          d="M45.2364 69.317L54.2364 97.317M28.9121 147.321L46.9121 127.321M148.907 63.0752L137.907 36.0752M123.026 113.198L145.026 90.1983M127.046 164.728L115.852 134.934M98.6662 124.336L74.6664 118.336M172.666 190.336L148.666 184.336M120.988 193.788L101.988 213.788M196.666 87.3358L168.666 80.3358"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
  </div>
  <div class="graphic_1">
    @if (graphic() === 'hexagon') {
      <svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M26.077 7L46.0622 18.5385V41.6154L26.077 53.1538L6.0918 41.6154V18.5385L26.077 7Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'rond') {
      <svg width="55" height="80" viewBox="0 0 55 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5497 43.3039L4.99414 77.0244M48.9999 26.2222C48.9999 37.3906 39.772 46.4444 28.3888 46.4444C17.0056 46.4444 7.7777 37.3906 7.7777 26.2222C7.7777 15.0538 17.0056 6 28.3888 6C39.772 6 48.9999 15.0538 48.9999 26.2222Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'cel') {
      <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M35 0V19M35 51V70M0 36H18M53 36H71M9.69314 61.8924L22.8087 48.7768M47.1658 24.4195L60.2814 11.304M62.3073 61.3665L49.1917 48.2509M24.8347 23.8939L11.7191 10.7783M51 36C51 44.2843 44.2843 51 36 51C27.7157 51 21 44.2843 21 36C21 27.7157 27.7157 21 36 21C44.2843 21 51 27.7157 51 36Z"
          stroke="var(--bs-secondary)"
          stroke-width="8"
        />
      </svg>
    }
    @if (graphic() === 'stippen') {
      <svg width="60" height="99" viewBox="0 0 60 99" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M54.5 79C54.5 87.0081 48.0081 93.5 40 93.5C31.9919 93.5 25.5 87.0081 25.5 79C25.5 70.9919 31.9919 64.5 40 64.5C48.0081 64.5 54.5 70.9919 54.5 79ZM34.5 20C34.5 28.0081 28.0081 34.5 20 34.5C11.9919 34.5 5.5 28.0081 5.5 20C5.5 11.9919 11.9919 5.5 20 5.5C28.0081 5.5 34.5 11.9919 34.5 20Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
        <line x1="34.9065" y1="63.0751" x2="23.9065" y2="36.0751" stroke="var(--bs-secondary)" stroke-width="11" />
      </svg>
    }
  </div>
  <div class="graphic_2">
    @if (graphic() === 'hexagon') {
      <svg width="78" height="60" viewBox="0 0 78 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M33.4854 38.9538L2.38965 53.9538M52.077 7L72.0622 18.5385V41.6154L52.077 53.1538L32.0918 41.6154V18.5385L52.077 7Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'rond') {
      <svg width="210" height="238" viewBox="0 0 210 238" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M51.9464 188.506L87.1615 142.42M70.0199 35.5623C95.0014 2.869 141.756 -3.38259 174.449 21.599C207.143 46.5805 213.394 93.3352 188.413 126.028C163.431 158.722 116.676 164.973 83.9832 139.992C51.2899 115.01 45.0383 68.2556 70.0199 35.5623ZM11.131 190.04C19.8494 178.63 36.3444 176.584 47.9735 185.47C59.6027 194.357 61.9623 210.81 53.2439 222.219C44.5255 233.629 28.0306 235.675 16.4014 226.789C4.77227 217.903 2.41264 201.45 11.131 190.04Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'cel') {
      <svg width="153" height="149" viewBox="0 0 153 149" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M77.5 0V39M77.5 109V149M0 77.5H40M113 77.5H153M23.819 130.856L51.7954 102.879M103.751 50.9237L131.727 22.9472M132.049 129.446L104.073 101.47M52.1174 49.5143L24.141 21.5379M109 76C109 93.6731 94.6731 108 77 108C59.3269 108 45 93.6731 45 76C45 58.3269 59.3269 44 77 44C94.6731 44 109 58.3269 109 76ZM81 76C81 78.2091 79.2091 80 77 80C74.7909 80 73 78.2091 73 76C73 73.7909 74.7909 72 77 72C79.2091 72 81 73.7909 81 76Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
    @if (graphic() === 'stippen') {
      <svg width="138" height="139" viewBox="0 0 138 139" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M56.5 20C56.5 28.0081 50.0081 34.5 42 34.5C33.9919 34.5 27.5 28.0081 27.5 20C27.5 11.9919 33.9919 5.5 42 5.5C50.0081 5.5 56.5 11.9919 56.5 20ZM132.5 90C132.5 98.0081 126.008 104.5 118 104.5C109.992 104.5 103.5 98.0081 103.5 90C103.5 81.9919 109.992 75.5 118 75.5C126.008 75.5 132.5 81.9919 132.5 90ZM76.5 77C76.5 85.0081 70.0081 91.5 62 91.5C53.9919 91.5 47.5 85.0081 47.5 77C47.5 68.9919 53.9919 62.5 62 62.5C70.0081 62.5 76.5 68.9919 76.5 77ZM34.5 119C34.5 127.008 28.0081 133.5 20 133.5C11.9919 133.5 5.5 127.008 5.5 119C5.5 110.992 11.9919 104.5 20 104.5C28.0081 104.5 34.5 110.992 34.5 119Z"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
        <path
          d="M57.0455 59.7282L45.8513 29.9341M102.666 85.3356L78.6659 79.3354M50.9873 88.788L31.9873 108.788"
          stroke="var(--bs-secondary)"
          stroke-width="11"
        />
      </svg>
    }
  </div>
</div>
